import { createContext } from 'react';

const templateProduccionContext = createContext();

export default templateProduccionContext;
